import { useOrganization } from '@/modules/backend/hooks/use-organization';

export const OrganizationName = (props: {orgId: string}) => {
  const { organization } = useOrganization(props.orgId);
  return <>{organization?.name}</>
}